import {
  ChatBubbleLeftRightIcon,
  ClockIcon,
  FlagIcon,
} from "@heroicons/react/24/outline";

import HeadlineStat from "../shared/HeadlineStat";
import { IEbayMessagingStats } from "../../models/EbayMessage";

const countOrDash = (value: number | null | undefined): string =>
  value === null || value === undefined
    ? "—"
    : value.toLocaleString("en-GB");

interface EbayMessagingStatsProps {
  stats?: IEbayMessagingStats;
  daysToSearch: number;
  /** When true, the "Awaiting response" tile acts as a filter. */
  awaitingActive?: boolean;
  onToggleAwaiting?: () => void;
  /** When true, the "Flagged" tile acts as a filter. */
  flaggedActive?: boolean;
  onToggleFlagged?: () => void;
}

export default function EbayMessagingStats({
  stats,
  daysToSearch,
  awaitingActive,
  onToggleAwaiting,
  flaggedActive,
  onToggleFlagged,
}: EbayMessagingStatsProps) {
  const windowLabel =
    daysToSearch === 1 ? "last 24h" : `last ${daysToSearch} days`;

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      <HeadlineStat
        value={countOrDash(stats?.totalMessaged)}
        label="Total number messaged"
        sublabel={`Customer messages in the ${windowLabel}`}
        tone="blue"
        icon={ChatBubbleLeftRightIcon}
      />
      <HeadlineStat
        value={countOrDash(stats?.totalAwaitingResponse)}
        label="Awaiting response"
        sublabel={
          onToggleAwaiting
            ? awaitingActive
              ? "Filter on — click to clear"
              : "Click to filter"
            : "No staff reply yet"
        }
        tone="amber"
        icon={ClockIcon}
        onClick={onToggleAwaiting}
        active={awaitingActive}
      />
      <HeadlineStat
        value={countOrDash(stats?.flaggedForAssistance)}
        label="Flagged for assistance"
        sublabel={
          onToggleFlagged
            ? flaggedActive
              ? "Filter on — click to clear"
              : "Click to filter"
            : "Escalated by staff / customer"
        }
        tone="rose"
        icon={FlagIcon}
        onClick={onToggleFlagged}
        active={flaggedActive}
      />
    </div>
  );
}
